export default __webpack_public_path__ + "static/media/Webinar_Srikanth.ce078a66.jpg";